<div class="intro-container">
  <div class="logo">
    <kp-reflect-animation [skipIntro]="true"></kp-reflect-animation>
  </div>
  <h1 class="intro-header"><ng-content></ng-content></h1>
  <p class="intro-content">Please review and accept to continue your {{ productName }} journey.</p>
  <button class="button button-pill button-intro" type="button" (click)="closeIntro.emit(true)">Continue</button>
</div>
